export default "<img [src]=\"image_url\" (error)=\"setDefaultImageUrl($event)\">"